import { DownloadOutlined, InboxOutlined, TagOutlined } from '@ant-design/icons';
import { Button, Popconfirm, Popover } from 'antd';
import React, { useState } from 'react';
import WorkOrderCreateButton from '../../common/WorkOrderCreateButton';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import BulkArchiveButton from '../../bulk_archive_button/BulkArchiveButton';
import OWButtonWithSupplierManagedLock from '../../common/OWButtonWithSupplierManagedLock';
import WorkOrderLabelsManagementPage from '../../work_order_labels_management_page/WorkOrderLabelsManagementPage';
import { isWorkOrderLabelsTrackEnabled } from '../../../data/workOrderStarLabels';
import { FILTER_OPTION_KEY_BUILDERS, FILTER_OPTIONS } from '../../../utils/FilterUtils';
import {
	FILTER_CONFIG_NAMES,
	WORK_ORDER_VIEW_SCOPE_FILTER_KEYS,
} from '../../../utils/DataConstants';

function RightActions({
	downloadCSV,
	switchDisplayMode,
	isDisplayModeActive,
	filters,
	counts,
	refreshTable,
	applyFilters,
	location,
	history,
}) {
	const dontShowExport = !downloadCSV;
	const [labelsModalVisible, setLabelsModalVisible] = useState(false);
	const openLabels = () => setLabelsModalVisible(true);
	const closeLabels = () => setLabelsModalVisible(false);
	const labelIsKey = FILTER_OPTION_KEY_BUILDERS[FILTER_OPTIONS.IS](FILTER_CONFIG_NAMES.WO_LABELS);
	// Clicking a label shows ALL work orders carrying it: from whichever tab the user is on
	// (active / archived / starred / a saved view) we move to the "All" view, drop that tab's
	// archive/star scope, reset any existing label option keys (is / is not / contains), and apply
	// the clicked label. Other active advanced filters are preserved.
	//
	// Two mechanisms, because the table reads filters from the URL only on mount and is otherwise
	// driven by its Redux filter state:
	//   - changing route  -> push the All URL; the freshly-mounted All table parses it on mount.
	//   - already on All   -> push wouldn't remount the table (its mount-time fetch never re-runs),
	//                         so apply via applyFilters, which refetches in place and re-syncs the URL.
	const handleLabelCountClick = (label) => {
		closeLabels();
		const pathname = (location && location.pathname) || '';
		const overviewBase = pathname.replace(/\/overview\/.*$/, '/overview');
		const allViewPath = `${overviewBase}/all`;
		const alreadyOnAllView = pathname.replace(/\/+$/, '') === allViewPath;

		const labelOptionKeys = Object.values(FILTER_OPTIONS).map((option) =>
			FILTER_OPTION_KEY_BUILDERS[option](FILTER_CONFIG_NAMES.WO_LABELS)
		);
		const keysToClear = [...labelOptionKeys, ...WORK_ORDER_VIEW_SCOPE_FILTER_KEYS];

		if (alreadyOnAllView && applyFilters) {
			const cleared = keysToClear.reduce((acc, key) => ({ ...acc, [key]: undefined }), {});
			applyFilters({ ...cleared, [labelIsKey]: String(label.id) });
			return;
		}
		if (history) {
			const params = new URLSearchParams((location && location.search) || '');
			keysToClear.forEach((key) => params.delete(key));
			params.set(labelIsKey, String(label.id));
			history.push(`${allViewPath}?${params.toString()}`);
			return;
		}
		if (!applyFilters) return;
		const cleared = labelOptionKeys.reduce((acc, key) => ({ ...acc, [key]: undefined }), {});
		applyFilters({ ...cleared, [labelIsKey]: String(label.id) });
	};
	// Labels management (sidebar) button + modal are hidden when the labels/stars flag is off.
	const labelsTrackEnabled = isWorkOrderLabelsTrackEnabled();
	return (
		<>
			<BulkArchiveButton filters={filters} counts={counts} refreshTable={refreshTable} />
			{labelsTrackEnabled && (
				<>
					<Button
						size="large"
						icon={<TagOutlined translate="" />}
						onClick={openLabels}
						className="shrink-0"
					/>
					{labelsModalVisible ? (
						<WorkOrderLabelsManagementPage
							visible={labelsModalVisible}
							onClose={closeLabels}
							onLabelsCatalogueSaved={refreshTable ? () => refreshTable(location) : undefined}
							onLabelCountClick={applyFilters ? handleLabelCountClick : undefined}
						/>
					) : null}
				</>
			)}
			<Popover
				content={
					dontShowExport
						? 'Due to large data volume, exporting is not feasible. Please contact support.'
						: null
				}
			>
				<OWButtonWithSupplierManagedLock
					size="large"
					icon={<DownloadOutlined translate="" />}
					className="inline-block-visible-md"
					onClick={downloadCSV}
					disabled={dontShowExport}
				/>
			</Popover>
			{/*
			<Button.Group size="large" className="inline-block-visible-xxl">
				<Button onClick={() => switchDisplayMode('list')} disabled={isDisplayModeActive('list')}>
					<i className="icons8-font icons8-bulleted-list-2" />
				</Button>
				<Button onClick={() => switchDisplayMode('map')} disabled={isDisplayModeActive('map')}>
					<i className="icons8-font icons8-location-marker" />
				</Button>
			</Button.Group>
			*/}
			<WorkOrderCreateButton />
		</>
	);
}

const mapStateToProps = (state, ownProps) => ({
	history: ownProps.history,
});

const mapDispatchToProps = (dispatch, ownProps) => ({});

const RightActionComp = withRouter(connect(mapStateToProps, mapDispatchToProps)(RightActions));

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	(dispatch, ownProps) => ({})
)(RightActionComp);
